module.exports = require('./helpers/bundle-url').getBundleURL('hcTqB') + "Badge1.50d61f89.png";